
<form #f="ngForm">

	<!-- Dynamic olarak deslim alınacak depoların listesini combobox'a bastığımız yerdir. -->
	<div class="form-group row">
		<label class="col-lg-2 offset-lg-3 col-form-label">{{ 'FE.ORDER.FORMS.LABELS.TOREQUESTWAREHOUSE.TOREQUESTWAREHOUSE' | localize }}<i class="text-danger">*</i></label>
		<div class="col-lg-4 kt-margin-b-10-tablet-and-mobile">
				<mat-select class="form-control"
							placeholder="{{ 'FE.ORDER.FORMS.PLACEHOLDERS.TOREQUESTWAREHOUSE.TOREQUESTWAREHOUSE' | localize }}"
							[(ngModel)]="selectedWarehouse"
							name="cmbToRequestWarehouse"
							#cmbToRequestWarehouse="ngModel"
							(selectionChange)="onChangeWareHouse()"
							required>
					<mat-option>{{ 'FE.ORDER.FORMS.PLACEHOLDERS.TOREQUESTWAREHOUSE.TOREQUESTWAREHOUSE' | localize }}</mat-option>
					<mat-option *ngFor="let wareHouse of (warehouses | async)" [value]="wareHouse">
						{{wareHouse.name}}
					</mat-option>
				</mat-select>

				<mat-error *ngIf="cmbToRequestWarehouse.hasError('required')">{{ 'FE.REQUIREDFIELDS.COMMON.REQUIRED' | localize }}</mat-error>

				<!--<span *ngIf="showIsRequiredMessage" class="help-block" style="color: tomato;">Lütfen Teslim Alınacak Depoyu Giriniz</span>-->


		</div>
	</div>

</form>

